import { render } from "./ClientDetails.vue?vue&type=template&id=3c5fefc0&ts=true"
import script from "./ClientDetails.vue?vue&type=script&lang=ts"
export * from "./ClientDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/asaskevich/Work/sequoia-cabinet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__